var _mask, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_601_55085",
    maskUnits: "userSpaceOnUse",
    x: -0.417725,
    y: -0.607422,
    width: 13,
    height: 13,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    x: -0.417725,
    y: -0.607422,
    width: 13,
    height: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.81615 0.392578H5.56615V5.37508H0.582275V6.62508H5.56615V11.6202H6.81615V6.62508H11.8087V5.37508H6.81615V0.392578Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.81615 0.392578H5.56615V5.37508H0.582275V6.62508H5.56615V11.6202H6.81615V6.62508H11.8087V5.37508H6.81615V0.392578Z",
    fill: "#B9BBBE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.81615 0.392578H7.19616V0.0125781H6.81615V0.392578ZM5.56615 0.392578V0.0125781H5.18615V0.392578H5.56615ZM5.56615 5.37508V5.75508H5.94616V5.37508H5.56615ZM0.582275 5.37508V4.99508H0.202275V5.37508H0.582275ZM0.582275 6.62508H0.202275V7.00508H0.582275V6.62508ZM5.56615 6.62508H5.94616V6.24508H5.56615V6.62508ZM5.56615 11.6202H5.18615V12.0002H5.56615V11.6202ZM6.81615 11.6202V12.0002H7.19616V11.6202H6.81615ZM6.81615 6.62508V6.24508H6.43615V6.62508H6.81615ZM11.8087 6.62508V7.00508H12.1887V6.62508H11.8087ZM11.8087 5.37508H12.1887V4.99508H11.8087V5.37508ZM6.81615 5.37508H6.43615V5.75508H6.81615V5.37508ZM6.81615 0.0125781H5.56615V0.772578H6.81615V0.0125781ZM5.18615 0.392578V5.37508H5.94616V0.392578H5.18615ZM5.56615 4.99508H0.582275V5.75508H5.56615V4.99508ZM0.202275 5.37508V6.62508H0.962275V5.37508H0.202275ZM0.582275 7.00508H5.56615V6.24508H0.582275V7.00508ZM5.18615 6.62508V11.6202H5.94616V6.62508H5.18615ZM5.56615 12.0002H6.81615V11.2402H5.56615V12.0002ZM7.19616 11.6202V6.62508H6.43615V11.6202H7.19616ZM6.81615 7.00508H11.8087V6.24508H6.81615V7.00508ZM12.1887 6.62508V5.37508H11.4287V6.62508H12.1887ZM11.8087 4.99508H6.81615V5.75508H11.8087V4.99508ZM7.19616 5.37508V0.392578H6.43615V5.37508H7.19616Z",
    fill: "#B9BBBE",
    mask: "url(#path-1-outside-1_601_55085)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.6f0580fb35cb47866489a043c47defa8.svg";
export { ForwardRef as ReactComponent };